(function ($) {

    if ($('.page-template-template-calculators').length) {
        var conversionsBlock = $('.calculator[data-calculator="oxide"] .conversions');
        var conversionA = conversionsBlock.find('.conversion-1');
        var conversionB = conversionsBlock.find('.conversion-2');
        var conversionInputA = conversionA.find('input');
        var conversionInputB = conversionB.find('input');
        var conversionLabelA = conversionA.find('label');
        var conversionLabelB = conversionB.find('label');

        var cleaveConversionA = new Cleave(conversionInputA, {
            numeral: true,
            numeralPositiveOnly: true,
            stripLeadingZeroes: false
        });

        var cleaveConversionB = new Cleave(conversionInputB, {
            numeral: true,
            numeralPositiveOnly: true,
            stripLeadingZeroes: false
        });

        if ($('.page-template-template-calculators').length) {
            var oxideSelection = $('.calculator-section .calculator[data-calculator="oxide"] select[name="conversion"]').select2({
                closeOnSelect: true,
                minimumResultsForSearch: -1,
                placeholder: $(this).data('input-placeholder'),
                data: oxideData
            });

            oxideSelection.on('select2:select', function() {
                var selection = oxideSelection.select2('data')[0];

                conversionLabelA.html(selection.label_a);
                conversionLabelB.html(selection.label_b);
                conversionInputA.attr('data-factor', selection.factor_a_to_b);
                conversionInputB.attr('data-factor', selection.factor_b_to_a);
                conversionInputA.val('');
                conversionInputB.val('');
            });

            conversionInputA.on('change, keyup', function() {
                var factor = $(this).attr('data-factor');
                var convertedValue = cleaveConversionA.getRawValue() * factor;

                if (convertedValue && !isNaN(convertedValue)) {
                    conversionInputB.val(convertedValue.toFixed(2));
                } else {
                    conversionInputB.val('');
                }
            })

            conversionInputB.on('change, keyup', function() {
                var factor = $(this).attr('data-factor');
                var convertedValue = cleaveConversionB.getRawValue() * factor;

                if (convertedValue && !isNaN(convertedValue)) {
                    conversionInputA.val(convertedValue.toFixed(2));
                } else {
                    conversionInputA.val('');
                }
            })
        }
    }

})(jQuery);